import axios from 'axios';
import {
  SUBMIT_LOG,
  SCANPACK_BUG_REPORT,
  SET_STATUS_MULTI_BOX,
  SUBMIT_LOG_FAIL,
  SCANPACK_BUG_REPORT_FAIL,
  SET_CURRRENT_ORDER,
  SET_BOX_CHAMP_STATE,
} from '../constants';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { GetOrderDetail } from './orderActions';
import { updateOfflineOrder } from './scanpackAction';
import { snapshotLogs, subtractSentLogs, appendLog } from '../utils/scanLogQueue';
import { PLAN_OP_EVENTS, newGestureUid } from '../components/scanpack/boxChampEvents';

const dedupeLogs = logs =>
  Array.from(new Map(logs.map(log => [JSON.stringify(log), log])).values());

let throttling = false;
// GROOV-4994 (defect cleanup #7): a flushed offline batch can span more than one order
// (the offline queue isn't scoped to the order currently open), so scanning only the
// FIRST plan-op entry meant a hand-off/substitution for the packer's CURRENT order never
// triggered a refetch whenever an earlier, different-order plan-op happened to be queued
// ahead of it. Collect every plan-op entry and prefer the one that matches the open
// order; only fall back to the first when the open order can't be determined at all
// (preserves the existing fail-open behavior for that case).
const refetchIfPlanOp = (dispatch, data, getState) => {
  const planOps = data.filter(
    entry => PLAN_OP_EVENTS.includes(entry?.event) && entry?.id != null
  );
  if (!planOps.length) return;
  const state = typeof getState === 'function' ? getState() : null;
  if (state?.features?.useScanpackScanningV2) {
    const openOrderId = state.scanPackScanning?.currentOrder?.id;
    if (openOrderId != null && planOps.some(entry => entry.id === openOrderId)) {
      dispatch({type: SET_BOX_CHAMP_STATE, payload: {planOpAckedAt: Date.now()}});
    }
    return;
  }
  const current = state?.order?.order ?? null;
  const currentId = current?.id ?? current?.basicinfo?.id ?? null;
  if (currentId == null) {
    dispatch(GetOrderDetail({id: planOps[0].id}));
    return;
  }
  const matching = planOps.find(entry => entry.id === currentId);
  if (matching) dispatch(GetOrderDetail({id: matching.id}));
};

const delayApi = async (dispatch, offlineData, getState) => {
  // const access_token = await AsyncStorage.getItem("access_token")
  // const url = await AsyncStorage.getItem("url")

  // let getItem = await AsyncStorage.getItem("logsArray")
  // let data = getItem && JSON.parse(getItem)
  // console.log("-->>>>>>>", data)
  if (!throttling) {
    throttling = true;
    dataCall(dispatch, offlineData, getState);
    apiInterval = true;
    // console.log("hiiiii")
    // clearTimeout(pausedTime)
    // console.log("clear time out ",clearTimeout(pausedTime))
    // --------
    // axios({
    //   method: 'post',
    //   url: `${url}/scan_pack/scan_pack_v2`,
    //   headers: { 'Authorization': `Bearer ${access_token}` },
    //   data: { data, app: "app" }
    // })
    //   .then(async (res) => {
    //     console.log("submit+++++ log", res)
    //     dispatch({
    //       type: SUBMIT_LOG,
    //       payload: res.data,
    //       time: new Date()
    //     })
    //     if (res.status === 200) {
    //       console.log("response savlog status", res.status)
    //       await AsyncStorage.removeItem("logsArray")
    //       data = []
    //       // delay = 7000
    //       // throttling = false
    //       // let getItem = await AsyncStorage.getItem("logsArray")
    //       // console.log("rrrrrrrr---->>",getItem)
    //       setTimeout(() => {
    //         console.log("throttling out", throttling)
    //         throttling = false
    //       }, 5000)

    //     }
    //   })
    //   .catch((error) => {
    //   })
    // ------
  }
  // else {
  //   console.log("byeeee")
  //   clearInterval(delay)
  // }
  // }
  // , 10000)
};

// let pausedTime;
// let delay = 8000
let apiInterval = false;

let count = 0;
let ss;
const dataCall = async (dispatch, offlineData, getState) => {
  const ss = setInterval(async () => {
    if (count <= 2 && count >= 0) {
      count = count + 1;
    } else {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      // Temp array = exactly what this request sends. Queued logs stay in logsArray until the
      // server acknowledges them (subtractSentLogs below), so a failed request needs no
      // backup/restore and logs saved mid-flight are not lost.
      const queued = await snapshotLogs();
      const fromQueue = queued.length > 0;
      let data = dedupeLogs(fromQueue ? queued : (offlineData || []));

      clearInterval(ss);
      throttling = false;
      count = 0;
      if (data?.length > 0) {
        axios({
          method: 'post',
          url: `${url}${offlineData?.length ? '/scan_pack/scan_pack_v2_ex' : '/scan_pack/scan_pack_v2'}`,
          headers: {Authorization: `Bearer ${access_token}`},
          data: {data , app: 'app'}
        })
          .then(async res => {
            dispatch({
              type: SUBMIT_LOG,
              payload: res.data,
              time: new Date()
            });
            if (res.status === 200) {
              dispatch(updateOfflineOrder([]))
              refetchIfPlanOp(dispatch, data, getState);
              if (fromQueue) {
                await subtractSentLogs(queued);
              }
              data = [];
              // console.log("current time interval",new Date(),res)

              // apiInterval = false

              // clearInterval(ss)
              count = 0;
            }
          })
          .catch(async error => {
            // Nothing was subtracted, so these logs stay queued and the next submit retries them.
            dispatch({
              type: SUBMIT_LOG_FAIL,
              payload: error?.response?.status,
              time: new Date()
            });
          });
      }
    }
  }, 100);
};
// One scan_pack_v2 request at a time, so two submits can't send the same logs. A submit requested
// while one is in flight re-runs when it finishes, so logs queued mid-flight are sent right away.
let submitInFlight = false;
let submitRerun = false;
let idleWaiters = [];

export const waitForSubmitIdle = () =>
  submitInFlight ? new Promise(resolve => idleWaiters.push(resolve)) : Promise.resolve();

export const LOG_UPLOAD_TIMEOUT_MS = 30000;

const sendQueuedLogs = async (dispatch, getState) => {
  if (submitInFlight) {
    submitRerun = true;
    return;
  }
  submitInFlight = true;
  try {
    const sentLogs = await snapshotLogs(); // temp array: exactly what this request sends
    if (!sentLogs.length) return;

    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    const res = await axios({
      method: 'post',
      url: `${url}/scan_pack/scan_pack_v2`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: {data: sentLogs, app: 'app'},
      timeout: LOG_UPLOAD_TIMEOUT_MS
    });
    dispatch({
      type: SUBMIT_LOG,
      payload: res.data,
      time: new Date()
    });
    if (res.status === 200) {
      refetchIfPlanOp(dispatch, sentLogs, getState);
      await subtractSentLogs(sentLogs);
    }
  } catch (error) {
    // Nothing was subtracted, so these logs stay queued and the next submit retries them.
    dispatch({
      type: SUBMIT_LOG_FAIL,
      payload: error?.response?.status,
      time: new Date()
    });
  } finally {
    submitInFlight = false;
    if (submitRerun) {
      submitRerun = false;
      sendQueuedLogs(dispatch, getState);
    } else {
      idleWaiters.splice(0).forEach(resolve => resolve());
    }
  }
};

export function SubmitLog(submitLog, offlineData) {
  // console.log("---submit log ", submitLog)
  return async (dispatch, getState) => {
    // const access_token = await AsyncStorage.getItem("access_token")
    // const url = await AsyncStorage.getItem("url")
    // let getItem = await AsyncStorage.getItem("logsArray")
    // // console.log("--",getItem)
    // let data = getItem && JSON.parse(getItem)
    // await AsyncStorage.getItem('logsArray').then((log) => {
    // if (data !== null) {

    // }
    // })
    // console.log("array -------->", data)
    // if(!throttling){
    //   clearTimeout(pausedTime)
    // }
    // let pausedTime = setTimeout(async () => {
    //   const access_token = await AsyncStorage.getItem("access_token")
    //   const url = await AsyncStorage.getItem("url")
    //   let getItem = await AsyncStorage.getItem("logsArray")
    //   // console.log("--",getItem)
    //   let data = getItem && JSON.parse(getItem)
    //   // return async(dispatch) => {
    //     // const access_token = await AsyncStorage.getItem("access_token")
    //     // const url = await AsyncStorage.getItem("url")
    //     // await AsyncStorage.getItem('logsArray').then((log) => {
    //     if (data?.length > 0) {
    //     console.log("delay function call after 2000 ms")
    //     axios({
    //       method: 'post',
    //       url: `${url}/scan_pack/scan_pack_v2`,
    //       headers: { 'Authorization': `Bearer ${access_token}` },
    //       data: { data, app: "app" }
    //     })
    //       .then(async (res) => {
    //         dispatch({
    //           type: SUBMIT_LOG,
    //           payload: res.data,
    //           time: new Date()
    //         })
    //         if (res.status === 200) {
    //           await AsyncStorage.removeItem("logsArray")
    //           data = []
    //         }
    //       })
    //       .catch((error) => {
    //       })
    //   }
    // }, delay)
    // const access_token = await AsyncStorage.getItem("access_token")
    // const url = await AsyncStorage.getItem("url")
    // let getItem = await AsyncStorage.getItem("logsArray")
    // let data = getItem && JSON.parse(getItem)
    // if(apiInterval){
    //   console.log("rohit-------->>>")
    // let setval = setTimeout(()=>{

    // console.log("count of interval here ",count)
    // if(count == 4){
    //   apiInterval = false
    //   clearInterval(setval)
    // }
    //     const ss = setInterval(async()=>{
    //       console.log("count------>>>>>>>>!",count)
    //       if(count <= 2 && count >= 0){
    //         count = count + 1
    //       }
    //       else{
    //         console.log("set interval out",ss)
    //         clearInterval(ss)
    //         count = 0
    //         if(data?.length > 0){
    //           axios({
    //             method: 'post',
    //             url: `${url}/scan_pack/scan_pack_v2`,
    //             headers: { 'Authorization': `Bearer ${access_token}` },
    //             data: { data, app: "app" }
    //           })
    //             .then(async (res) => {
    //               dispatch({
    //                 type: SUBMIT_LOG,
    //                 payload: res.data,
    //                 time: new Date()
    //               })
    //               if (res.status === 200) {
    //                 console.log("current time interval",new Date())
    //                 await AsyncStorage.removeItem("logsArray")
    //                 data = []
    //                 // apiInterval = false

    //                 // clearInterval(ss)
    //                 // count = 0
    //               }
    //             })
    //             .catch((error) => {
    //             })
    //         }
    //       }
    // },1000)
    // },4000)
    // }
    if (submitLog === 'submitLog') {
      await sendQueuedLogs(dispatch, getState);
    } else {
      delayApi(dispatch, offlineData, getState);
    }
  };
}

export function MultiBoxSaveLog(submitLog,id, offlineData){
  return async dispatch => {
    // if (submitLog === 'submitLog') {
      // console.log(":-))")
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const queued = await snapshotLogs();
      const fromQueue = queued.length > 0;
      let data = dedupeLogs(fromQueue ? queued : (offlineData || []));

      if (data?.length > 0) {
        await axios({
          method: 'post',
          url: `${url}${offlineData?.length ? '/scan_pack/scan_pack_v2_ex' : '/scan_pack/scan_pack_v2'}`,
          headers: {Authorization: `Bearer ${access_token}`},
          data: {data, app: 'app'}
        })
          .then(async res => { 
            if (res.status == 200) {
              if (fromQueue) {
                await subtractSentLogs(queued);
              }
              dispatch(
                GetOrderDetail(id)
              );          
              dispatch({
                type: SUBMIT_LOG,
                payload: res.data,
                time: new Date()
              });
               dispatch({
                 type:SET_STATUS_MULTI_BOX,
                 payload:res.data.status
               })

              data = [];
              dispatch(updateOfflineOrder([]));
            }
          })
          .catch(async error => {
            dispatch({
              type: SUBMIT_LOG_FAIL,
              payload: error?.response?.status,
              time: new Date()
            });
          });
      }
      // })
      // }
    // } else {
    //   delayApi(dispatch);
    // }
    }
}

export function ScanPackBugReport(data) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url: `${url}/scan_pack/scan_pack_bug_report.json`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: data
    })
      .then(async res => {
        dispatch({
          type: SCANPACK_BUG_REPORT,
          payload: {
            data: res.data,
            time: new Date()
          }
        });
        if (res.status === 200) {
          await AsyncStorage.removeItem('Logging');
        }
      })
      .catch(error => {
        dispatch({
          type: SCANPACK_BUG_REPORT_FAIL,
          payload: {
            data: error?.response?.status,
            time: new Date()
          }
        });
      });
  };
}

const setOrderDetails = (data) => {
  return {
    type: SET_CURRRENT_ORDER,
    payload: data,
  };
};

export const fetchUser = (data) => {
  return (dispatch) => {
    dispatch(setOrderDetails(data));
  }
}

// =============================================================
// WMS L2/L3 gated-scan round trip
//
// Every other scan on this screen is optimistic: the log is queued to AsyncStorage and flushed
// to `scan_pack_v2` on a throttled batch, fire-and-forget, because there is nothing server-side
// that can reject a normal scan. An L2/L3-gated scan is different — the SERVER decides whether to
// commit it (Groovepacker::Inventory::LotScanGate), so for that one scan we submit it alone,
// synchronously, and only touch local/committed state once we know what the server did with it.
//
// Contract (see groovepacker-wms-integration app/services/concerns/wms_lot_scan_gate.rb and
// ScanPack::ScanBarcodeService#do_if_packing_count_not_present): the packer's answer travels as a
// top-level `wms_lot_answer` key on the log entry, exactly like `product_id`/`kit_product_id`
// already do. A blocked scan comes back as `result.data.wms_lot` with `ask: true` and, once the
// packer has already answered wrong once, an `error` string.
//
// BACKEND GAP CLOSED (2026-08-07, groovepacker-wms-integration branch integration/wms-inventory):
// `ScanPackController#scan_pack_v2` / `#scan_pack_v2_ex` now render a top-level `result: @result`
// key alongside the pre-existing `response`/`status`/`timestamp` (additive — those three are
// byte-identical to before). `result.data.wms_lot` is the new, correct path. The old
// `response.data.wms_lot` / `data.wms_lot` paths are kept as fallbacks for safety but should never
// actually be hit against a fixed backend — `response` only ever echoes the request.
export const readWmsLotAsk = (responseData) => {
  return (
    responseData?.result?.data?.wms_lot ||
    responseData?.response?.data?.wms_lot ||
    responseData?.data?.wms_lot ||
    null
  );
};

// Mirrors readWmsLotAsk's three-path fallback (see doc comment above it) for the sibling
// `wms_zero_inventory` key (Z1-Z3 ladder), added the same day (2026-08-07) alongside `wms_lot`.
//
// Two passes exist server-side: pass 1 (`wms_zero_inventory` itself) is present whenever there
// is a shortage at ANY Z rung (Z1/Z2/Z3) and is purely informational — it must NOT stop the
// packer. Pass 2 (`wms_zero_inventory.receiving`) is present ONLY when Z3 is actually holding the
// packer for stop-and-receive. This helper deliberately returns pass 2, not pass 1 — returning
// pass 1 would incorrectly stop the packer on a Z1/Z2 informational-only shortage, which is not
// this ladder's job (see the sibling comment on checkWmsLotVerification's Z-ladder carve-out in
// sharedValidationUtils.js). Returns `null` when there is no shortage, or a shortage exists but
// isn't currently stopping the packer (Z1/Z2, or a resolved/bypassed Z3).
export const readWmsZeroAsk = (responseData) => {
  const zeroInventory =
    responseData?.result?.data?.wms_zero_inventory ||
    responseData?.response?.data?.wms_zero_inventory ||
    responseData?.data?.wms_zero_inventory ||
    null;

  return zeroInventory?.receiving || null;
};

// Shared transport for the single-entry synchronous round trip used by BOTH gated ladders
// (L2/L3's submitGatedScan and Z1-Z3's submitGatedZeroScan below) — same endpoint, same
// single-entry body, same fail-soft posture. Never throws: a network/client failure returns
// `null` data so callers degrade to "let the scan through", matching WmsLotScanGate/Z-ladder's
// own `rescue StandardError` -> allow posture on the backend. Kept private (not exported) so the
// two ladders cannot drift on request shape while still reading the response differently.
async function postSingleGatedScan(logEntry) {
  const entry = logEntry.uid ? logEntry : {...logEntry, uid: newGestureUid()};
  try {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'post',
      url: `${url}/scan_pack/scan_pack_v2`,
      headers: { Authorization: `Bearer ${access_token}` },
      data: { data: [entry], app: 'app' },
      timeout: LOG_UPLOAD_TIMEOUT_MS
    });

    return response?.data;
  } catch (error) {
    if (!error?.response) {
      try {
        await appendLog(entry);
      } catch (queueError) {
        return null;
      }
    }
    return null;
  }
}

// Submits exactly ONE scan log entry (never batched with anything else) and waits for the
// server's verdict before the caller touches any local/committed state. Returns the ask payload
// (`{ ask: true, level, error?, ... }`) when the server blocked the scan, or `null` when it
// committed. Never throws — a network/client failure degrades to "let the scan through" (`null`),
// matching WmsLotScanGate's own fail-soft posture (`rescue StandardError` -> `false`, i.e. "allow
// the scan"): a WMS call failing must never itself block a packing station.
export async function submitGatedScan(logEntry) {
  const responseData = await postSingleGatedScan(logEntry);
  return readWmsLotAsk(responseData);
}

// Z1-Z3 sibling of submitGatedScan — same single-entry synchronous round trip, but reads the
// `wms_zero_inventory.receiving` ask instead of `wms_lot`. Returns the receiving payload when Z3
// is actually stopping the packer, or `null` when the scan committed (no shortage, an
// informational-only Z1/Z2 shortage, or a network/client failure — all three are indistinguishable
// here by design, matching the same fail-soft posture as submitGatedScan).
export async function submitGatedZeroScan(logEntry) {
  const responseData = await postSingleGatedScan(logEntry);
  return readWmsZeroAsk(responseData);
}
